<script>
    export let date,
               title,
               passage,
               speaker,
               href,
               videoHref;

    let speakers = {
        'David Hanson': {
            img: 'HansonDavid.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=David_Hanson'
        },
        'David Whitla': {
            img: 'WhitlaDavid.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=David_Whitla'
        },
        'Edward Donnelly': {
            img: 'DonnellyEdward.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=Pastor_Edward_Donnelly'
        },
        'Ian Wise': {
            img: 'WiseIan.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=Ian_E._Wise'
        },
        'Jay Dharan': {
            img: 'DharanJay.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=Jay_Dharan'
        },
        'Joe Smith': {
            img: 'generic.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=Joe_Smith_RPCNA'
        },
        'Michael Myers': {
            img: 'MyersMichael.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=Michael_Myers'
        },
        'Tre Cranford': {
            img: 'generic.png',
            sermonAudioHref: 'https://www.sermonaudio.com/search.asp?speakeronly=true&keyword=Tre_Cranford'
        }
    };

    $: speakerImg = speakers[speaker].img;
    $: speakerSermonAudioHref = speakers[speaker].sermonAudioHref;

</script>

<style>
    main {
        margin: 1em 0px;
        background-color: #fff;
        border-radius: 10px;
        padding: 1em;
    }

    @media all and (min-width: 520px) {
        main {
            display: flex;
        }
    }

    .header {
        display: flex;
    }

    img.speaker {
        margin-right: 9px;
    }

    .title {
        color: #363636;
        display: block;
        font-size: 16px;
        font-weight: 700;
    }

    .speaker-passage {
        color: #697882;
        font-size: 14px;
    }

    .date-listen {
        margin-left: auto;
        color: #697882;
        font-size: 14px;
        text-align: right;
        /*line-height: 1.4;*/
    }

    @media all and (max-width: 520px) {
        .date-listen {
            text-align: right;
            margin-top: 1em;
        }
    }

    a {
        color: #fc644d;
        text-decoration: none;
    }
</style>

<main>
    <div class="header">
        <img src={speakerImg} alt={speaker} class="speaker" width="35" height="35">
        <div>
            <div class="title">{title}</div>
            <div class="speaker-passage">
                <div class="passage">{passage}</div>
                <div class="speaker"><a href={speakerSermonAudioHref} target="_blank" rel="noopener noreferrer">{speaker}</a></div>
            </div>
        </div>
    </div>

    <div class="date-listen">
        <div class="date">{date}</div>
        {#if href}
            <div><a {href} target="blank">Escucha MP3</a></div>
        {:else}
            <div>(MP3 no disponible)</div>
        {/if}

        {#if videoHref}
            <div><a href={videoHref} target="blank">Ver video</a></div>
        {:else}
            <div>(Video no disponible)</div>
        {/if}
    <div>
</main>
